import React from 'react';
import PolygonDrawer from './polygon-drawer';

const PolygonStateHandler = (props) => {
  const { 
    points, 
    setLinePoints,
    setStartLinePoints,
    setEndLinePoints,
    setAreaPoints, 
    currentCameraImage, 
    selectedRowIndex, 
    rowsData 
  } = props;

  // Get the current row data
  const currentRow = rowsData?.[selectedRowIndex];
  
  // Check if "show all" is enabled
  const isShowAll = currentRow?.is_show_all;

  // Debug logging
  React.useEffect(() => {
    if (isShowAll) {
      console.log('PolygonStateHandler - Show All Mode:', {
        isShowAll,
        areaPoints: currentRow?.area,
        linePoints: currentRow?.line,
        startLinePoints: currentRow?.start_line,
        endLinePoints: currentRow?.end_line
      });
    }
  }, [isShowAll, currentRow]);

  return (
    <>
      <PolygonDrawer
        value={points}
        setAreaPoints={(val) => setAreaPoints(val)}
        setLinePoints={(val) => setLinePoints(val)}
        setStartLinePoints={(val) => setStartLinePoints(val)}
        setEndLinePoints={(val) => setEndLinePoints(val)}
        closePolygonThreshold="3"
        selectedRowIndex={selectedRowIndex}
        rowsData={rowsData}
        isShowAll={isShowAll}
        areaPoints={currentRow?.area || []}
        linePoints={currentRow?.line || []}
        startLinePoints={currentRow?.start_line || []}
        endLinePoints={currentRow?.end_line || []}
      >
        {
          currentCameraImage ?
            <img src={`data:image/*;base64,${currentCameraImage}`} className="polygon-img" />
            :
            ""
        }
      </PolygonDrawer>
    </>
  )
}

export default PolygonStateHandler
